import { useForm } from "@inertiajs/react";
import type { FormEvent } from "react";

import AuthCard from "@/components/AuthCard";
import Button from "@/components/Button";
import PasswordField from "@/components/PasswordField";
import { passwords } from "@/routes";

export default function PasswordsEdit({
  resetPasswordToken,
}: {
  resetPasswordToken: string;
}) {
  const form = useForm({
    password: "",
    password_confirmation: "",
    reset_password_token: resetPasswordToken,
  });

  function submit(e: FormEvent) {
    e.preventDefault();
    form.transform((data) => ({ password: data }));
    form.patch(passwords.update().url);
  }

  return (
    <AuthCard
      title="Nueva contraseña"
      subtitle="Elige una nueva contraseña para tu cuenta."
    >
      <form onSubmit={submit} className="mx-auto flex max-w-xl flex-col gap-4">
        <PasswordField
          name="password"
          placeholder="Nueva contraseña"
          autoComplete="new-password"
          value={form.data.password}
          onChange={(e) => form.setData("password", e.target.value)}
          minLength={6}
          required
        />

        <PasswordField
          name="password_confirmation"
          placeholder="Confirmar contraseña"
          autoComplete="new-password"
          value={form.data.password_confirmation}
          onChange={(e) =>
            form.setData("password_confirmation", e.target.value)
          }
          minLength={6}
          required
        />

        <Button
          type="submit"
          disabled={form.processing}
          className="mt-2 w-full"
        >
          Cambiar contraseña
        </Button>
      </form>
    </AuthCard>
  );
}
